<template>
  <FaIcon :icon="CAMERA_TIMELAPSE_ICON" />
</template>

<script setup lang="ts">
import { CAMERA_TIMELAPSE_ICON } from '@/constants/camera';
</script>
